import { Routes } from '@angular/router';
import { DefaultLayoutComponent, TeamLayoutComponent, HomeHeaderComponent, } from './layout';
import { AuthGuard, TeamAuthGuard, TeamApplicationAuthGuard } from './views/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    redirectTo: '/sign-in',
    pathMatch: 'full'
  },

  {
    path: '',
    component: HomeHeaderComponent,
    data: {
      title: 'Login Page',
      /** 登入／註冊公開頁：統一套用淺色主題變數 */
      preLoginUnifiedTheme: true,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: {
          title: 'Home Page',
        },
        loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'sign-in',
        loadComponent: () => import('./views/pages/sign-in/sign-in.component').then(m => m.SignInComponent),
      },
      {
        path: 'register',
        loadComponent: () => import('./views/pages/register-page/register-page.component').then(m => m.RegisterPageComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./views/pages/forgot-password-page/forgot-password-page.component').then(m => m.ForgotPasswordPageComponent),
      },
      {
        path: 'feature/ima-one',
        loadComponent: () => import('./views/pages/feature/ima-one/ima-one.component').then(m => m.ImaOneComponent),
      },
      {
        path: 'feature/imaginus',
        loadComponent: () => import('./views/pages/feature/imaginus/imaginus.component').then(m => m.ImaginusComponent),
      },
      {
        path: 'feature/service',
        loadComponent: () => import('./views/pages/feature/service/service.component').then(m => m.ServiceComponent),
      },
      {
        path: 'feature/service/esco/electricity-price-management',
        loadComponent: () => import('./views/pages/feature/service/esco/electricity-price-management/electricity-price-management.component').then(m => m.ElectricityPriceManagementComponent),
      },
      {
        path: 'feature/service/esco/electricity-management',
        loadComponent: () => import('./views/pages/feature/service/esco/electricity-management/electricity-management.component').then(m => m.ElectricityManagementComponent),
      },
      {
        path: 'feature/service/cems',
        loadComponent: () => import('./views/pages/feature/service/cems/cems.component').then(m => m.CemsComponent),
      },
      {
        path: 'contact-us',
        loadComponent: () => import('./views/pages/contact-us/contact-us.component').then(m => m.ContactUsComponent),
      },
      {
        path: 'discover/features',
        loadComponent: () => import('./views/pages/discover-features/discover-features.component').then(m => m.DiscoverFeaturesComponent),
      },
      {
        path: 'discover/solutions',
        loadComponent: () => import('./views/pages/discover-solutions/discover-solutions.component').then(m => m.DiscoverSolutionsComponent),
      },
      {
        path: 'discover/cases',
        loadComponent: () => import('./views/pages/discover-cases/discover-cases.component').then(m => m.DiscoverCasesComponent),
      },
      {
        path: 'about',
        loadComponent: () => import('./views/pages/about/about.component').then(m => m.AboutComponent),
      },
      {
        path: 'service/analysis',
        loadComponent: () => import('./views/pages/service-analysis/service-analysis.component').then(m => m.ServiceAnalysisComponent),
      },
      {
        path: 'service/audit',
        loadComponent: () => import('./views/pages/service-audit/service-audit.component').then(m => m.ServiceAuditComponent),
      },
      {
        path: 'service/maintenance',
        loadComponent: () => import('./views/pages/service-maintenance/service-maintenance.component').then(m => m.ServiceMaintenanceComponent),
      },
      {
        path: 'service/consulting',
        loadComponent: () => import('./views/pages/service-consulting/service-consulting.component').then(m => m.ServiceConsultingComponent),
      },
      {
        path: 'pricing',
        loadComponent: () => import('./views/pages/pricing/pricing.component').then(m => m.PricingComponent),
      },
      {
        path: 'contact',
        loadComponent: () => import('./views/pages/contact-sales/contact-sales.component').then(m => m.ContactSalesComponent),
      },
      {
        path: 'download-desktop',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'legal/terms',
        data: { doc: 'terms' },
        loadComponent: () => import('./views/pages/legal/legal.component').then(m => m.LegalComponent),
      },
      {
        path: 'legal/privacy',
        data: { doc: 'privacy' },
        loadComponent: () => import('./views/pages/legal/legal.component').then(m => m.LegalComponent),
      },
      /**
       * 站外（App Store 審查、電子報、簽約文件）常直接引用 /terms 與 /privacy，
       * 這兩個短網址要免登入可讀；/terms/:doc 仍留給登入後的簽署流程。
       */
      {
        path: 'terms',
        redirectTo: 'legal/terms',
        pathMatch: 'full',
      },
      {
        path: 'privacy',
        redirectTo: 'legal/privacy',
        pathMatch: 'full',
      },
      {
        /** 舊版簽署頁連結（信件、截圖仍在流通）不要落到登入牆或 404。 */
        path: 'terms/create_enterprise',
        redirectTo: 'legal/terms',
        pathMatch: 'full',
      },
      {
        path: 'help',
        loadComponent: () => import('./views/pages/user-guide/user-guide.component').then(m => m.UserGuideComponent),
      }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/admin/routes').then((m) => m.routes)
      },
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadComponent: () => import('./imaginus/imaginus-page.component').then((m) => m.ImaginusPageComponent),
        data: { title: 'Imaginus', imaginusContext: 'individual' }
      },
      {
        path: 'imaginus',
        canActivate: [AuthGuard],
        loadComponent: () => import('./imaginus/imaginus-page.component').then((m) => m.ImaginusPageComponent),
        data: { title: 'Imaginus', imaginusContext: 'individual' }
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'project',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/project/routes').then((m) => m.routes)
      },
      {
        path: 'device',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/device/routes').then((m) => m.routes)
      },
      {
        path: 'inventory',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/inventory/routes').then((m) => m.routes)
      },
      {
        path: 'bill-analysis',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/bill-analysis/routes').then((m) => m.routes)
      },
      {
        path: 'customer_service',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/customer_service/routes').then((m) => m.routes)
      },
      {
        path: 'discover',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/discover/routes').then((m) => m.routes)
      },
      {
        path: 'places',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/places/routes').then((m) => m.routes)
      },
      {
        path: 'groups',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/groups/routes').then((m) => m.routes)
      },
      {
        path: 'terms',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/terms/routes').then((m) => m.routes)
      },
      {
        path: 'mailbox',
        canActivate: [AuthGuard],
        loadComponent: () => import('./views/mailbox/mailbox.component').then(m => m.MailboxComponent),
        data: {
          title: 'RoleAccess Page'
        }
      },
      {
        path: 'task-manager',
        canActivate: [AuthGuard],
        loadComponent: () => import('./views/task-manager/task-manager.component').then(m => m.TaskManagerComponent),
        data: {
          title: 'Task Manager Page'
        }
      },
      {
        path: 'electricity-detail/:event_id',
        canActivate: [AuthGuard],
        loadComponent: () => import('./views/project/electricity-detail/electricity-detail.component').then(m => m.ElectricityDetailComponent),
        data: {
          title: 'Electricity Detail'
        }
      },
      {
        path: 'documentDemands',
        canActivate: [AuthGuard],
        loadComponent: () => import('./views/documentDemands/documentDemands.component').then((m) => m.DocumentDemandsComponent)
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadComponent: () => import('./views/settings/settings.component').then((m) => m.SettingsComponent)
      },
      {
        path: 'application',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/application/routes').then((m) => m.routes)
      },
      {
        path: 'desktop-device-monitor',
        canActivate: [AuthGuard],
        loadComponent: () => import('./team/desktop-device-monitor/desktop-device-monitor.component').then((m) => m.DesktopDeviceMonitorComponent)
      },
    ]
  },
  {
    path: 'team/:team_code',
    component: DefaultLayoutComponent,
    canActivate: [TeamAuthGuard],
    data: {
      title: 'Home',
      shellMode: 'unified',
    },
    children: [
      {
        path: 'task-manager',
        canActivate: [TeamAuthGuard],
        loadComponent: () =>
          import('./views/task-manager/task-manager-redirect.component').then(
            (m) => m.TaskManagerRedirectComponent,
          ),
      },
      {
        path: 'billing',
        redirectTo: 'settings',
        pathMatch: 'full',
      },
      {
        path: 'payment-and-receipt',
        canActivate: [TeamAuthGuard],
        loadComponent: () =>
          import('./team/billing-hub/payment-receipt-redirect.component').then(
            (m) => m.PaymentReceiptRedirectComponent,
          ),
      },
      {
        path: 'billing-hub',
        canActivate: [TeamAuthGuard],
        loadComponent: () =>
          import('./team/billing-hub/billing-hub-redirect.component').then((m) => m.BillingHubRedirectComponent),
      },
      {
        path: 'payment/checkout',
        canActivate: [TeamAuthGuard],
        loadComponent: () => import('./team/payment-checkout/payment-checkout.component').then((m) => m.PaymentCheckoutComponent)
      },
      {
        path: 'payment/return',
        canActivate: [TeamAuthGuard],
        loadComponent: () => import('./team/payment-return/payment-return.component').then((m) => m.PaymentReturnComponent)
      },
      {
        path: 'discover',
        canActivate: [TeamAuthGuard],
        loadChildren: () => import('./team/discover/routes').then((m) => m.routes)
      },
      {
        path: 'settings',
        canActivate: [TeamAuthGuard],
        loadComponent: () => import('./team/settings/settings.component').then((m) => m.SettingsComponent)
      },
      {
        path: 'home',
        canActivate: [TeamAuthGuard],
        loadComponent: () =>
          import('./layout/team-home-redirect.component').then((m) => m.TeamHomeRedirectComponent),
      },
      {
        path: 'application',
        canActivate: [TeamAuthGuard],
        loadChildren: () => import('./team/application/routes').then((m) => m.routes)
      },
            {
        path: 'mailbox',
        canActivate: [TeamAuthGuard],
        loadChildren: () => import('./team/mailbox/routes').then((m) => m.routes)
      },
      {
        path: 'user-profile',
        canActivate: [TeamAuthGuard],
        loadComponent: () => import('./team/user-profile/user-profile.component').then((m) => m.UserProfileComponent)
      },
      {
        path: 'chats',
        canActivate: [TeamAuthGuard],
        loadComponent: () => import('./team/chat/chat-inbox.component').then((m) => m.ChatInboxComponent)
      },
      {
        path: 'chats/:conversationKey',
        canActivate: [TeamAuthGuard],
        loadComponent: () => import('./team/chat/chat-inbox.component').then((m) => m.ChatInboxComponent)
      },
    ]
  },
  {
    path: 'project/device-dashboard-edit/:project_code/:projectplot_name',
    canActivate: [AuthGuard],
    loadComponent: () => import('./views/project/device-dashboard-edit/device-dashboard-edit.component').then(m => m.DeviceDashboardEditComponent),
    data: {
      title: 'Device-Dashboard-Edit'
    }
  },
  {
    path: 'project/device-dashboard-view/:project_code/:projectplot_name',
    canActivate: [AuthGuard],
    loadComponent: () => import('./views/project/device-dashboard-view/device-dashboard-view.component').then(m => m.DeviceDashboardViewComponent),
    data: {
      title: 'Device-Dashboard-View'
    }
  },
  {
    path: 'team/:team_code/application/1/places/:places_id/plot-edit/:plot_id',
    canActivate: [TeamApplicationAuthGuard],
    loadComponent: () => import('./../app/team/application/energy_management_project/places/plot-edit/plot-edit.component').then(m => m.PlotEditComponent),
    data: {
      title: 'Plot edit'
    }
  },
  {
    path: 'team/:team_code/application/1/places/:places_id/plot-view/:plot_id',
    canActivate: [TeamApplicationAuthGuard],
    loadComponent: () => import('./../app/team/application/energy_management_project/places/plot-view/plot-view.component').then(m => m.PlotViewComponent),
    data: {
      title: 'Plot view'
    }
  },
  {
    path: 'team/:team_code/application/2/places/:places_id/plot-view/:plot_id',
    canActivate: [TeamApplicationAuthGuard],
    loadComponent: () => import('./../app/team/application/energy_management_service/places/plot-view/plot-view.component').then(m => m.PlotViewComponent),
    data: {
      title: 'Plot view'
    }
  },
  {
    path: 'select-identity',
    canActivate: [AuthGuard],
    loadComponent: () => import('./views/pages/select-identity/select-identity.component').then(m => m.SelectIdentityComponent),
    data: {
      title: 'Select Identity'
    }
  },
  {
    path: 'register-success',
    loadComponent: () => import('./views/pages/register-success/register-success.component').then(m => m.RegisterSuccessComponent),
    data: {
      title: 'Registration successful',
      preLoginUnifiedTheme: true,
    }
  },
  {
    path: 'tpc-officer',
    canActivate: [AuthGuard],
    loadComponent: () => import('./views/tpc-officer/tpc-officer-workbench.component').then(m => m.TpcOfficerWorkbenchComponent),
    data: { title: 'TPC Officer Workbench' }
  },
  {
    path: 'register-failed',
    loadComponent: () => import('./views/pages/register-failed/register-failed.component').then(m => m.RegisterFailedComponent),
    data: {
      title: 'Registration failed',
      preLoginUnifiedTheme: true,
    }
  },
  {
    path: 'reset-pwd/:token',
    loadComponent: () => import('./views/pages/reset-pwd/reset-pwd.component').then(m => m.ResetPwdComponent),
    data: {
      title: 'Reset password',
      preLoginUnifiedTheme: true,
    }
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Reset password',
      preLoginUnifiedTheme: true,
    }
  },
  { path: '**', redirectTo: '404' }
];
